import { Reason } from '@/types';

import { neededInformationFiltered } from './reason.adapters';

export const canAutoAdvanceReason = ({
  reason,
  isMultiProduct,
}: {
  reason: Reason;
  isMultiProduct?: boolean;
}): boolean => {
  const neededInformation = neededInformationFiltered(
    reason.neededInformation,
    isMultiProduct,
  );

  const hasNeededInformation = Boolean(neededInformation?.length);

  return (
    !hasNeededInformation &&
    !reason.mandatoryComment &&
    !reason.isDiagnosticTreeAvailable
  );
};
